import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d8703d58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap justify-center items-center w-full p-24" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-6xl font-bold text-center pb-12" }, " Ben je zeker dat je wil afsluiten? ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-3xl text-center" }, [
  /*#__PURE__*/_createTextVNode(" Wanneer je afsluit blijven alle beelden die in je verhalenbox zitten bewaard."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Je kan deze thuis raadplegen via de website met jouw persoonlijke code: ")
], -1))
const _hoisted_5 = { class: "flex justify-center items-center pt-48" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_box_visit_code = _resolveComponent("box-visit-code")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_BaseModal = _resolveComponent("BaseModal")!

  return (_openBlock(), _createBlock(_component_BaseModal, {
    scroll: false,
    "modal-state": _ctx.ShutdownModalState.state,
    onHideModal: _ctx.closeShutdownModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode(_component_box_visit_code, {
            code: _ctx.code,
            class: "my-12"
          }, null, 8, ["code"])
        ]),
        _createElementVNode("section", _hoisted_5, [
          _createVNode(_component_base_button, {
            class: "shadow mr-8",
            "custom-style": "touchtable-white-round",
            "icon-shown": true,
            text: "Ja, sessie afsluiten",
            onClick: _ctx.goToCodeScreen
          }, null, 8, ["onClick"]),
          _createVNode(_component_base_button, {
            class: "shadow",
            "custom-style": "touchtable-green-round",
            "icon-shown": false,
            text: "Nee, terug naar het archief",
            onClick: _ctx.goToStoriesScreen
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modal-state", "onHideModal"]))
}